export enum HttpHeaderKey {
  CONTENT_TYPE = "Content-Type",
  AUTHORIZATION = "Authorization"
}
